import { z } from "zod";
export const CourseSettingsSchema = z.object({
  sequential: z.boolean(),
  requiresGettingStarted: z.boolean().optional(),
  ratings: z.boolean(),
  helena: z.object({ enabled: z.boolean(), guidance: z.string().max(2000) }),
});
export type CourseSettings = z.infer<typeof CourseSettingsSchema>;
export const defaultSettings = (): CourseSettings => ({
  sequential: false,
  ratings: false,
  helena: { enabled: false, guidance: "" },
});
